export default "__VITE_ASSET__b8cec120__"